import { slideToggle } from './motion.js';

const OPEN_CLASS = '-js-open';

/**
 * `<dt class="js-accordion__button">` + 次の `<dd>` で構成されるアコーディオン。
 * dt 全体がクリック領域、内側の button が支援技術向けのコントロールになる。
 */
export const initAccordion = () => {
  const triggers = document.querySelectorAll('.js-accordion__button');

  triggers.forEach((trigger, index) => {
    const panel = trigger.nextElementSibling;
    if (!panel) return;

    const button = trigger.querySelector('button');
    const isOpen = () => trigger.classList.contains(OPEN_CLASS);

    if (!panel.id) panel.id = `accordion-panel-${index + 1}`;
    panel.hidden = !isOpen();

    if (button) {
      button.setAttribute('aria-controls', panel.id);
      button.setAttribute('aria-expanded', String(isOpen()));
    }

    trigger.addEventListener('click', () => {
      const next = !isOpen();
      trigger.classList.toggle(OPEN_CLASS, next);
      button?.setAttribute('aria-expanded', String(next));
      slideToggle(panel, next);
    });
  });
};
